"use strict";
// Copyright © Veeam Software Group GmbH
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SplitLayoutInteractor = void 0;
const rxjs_1 = require("rxjs");
const core_1 = require("@veeam/core");
function getSizeValue(value, rootValue) {
    if (Number.isInteger(value) || value > 1) {
        return value;
    }
    return rootValue * value;
}
function getLimitedValueByOptionalMinMaxValue({ value, minValue, maxValue }) {
    const maxResultValue = minValue ? Math.max(minValue, value) : value;
    return maxValue ? Math.min(maxValue, maxResultValue) : maxResultValue;
}
class SplitLayoutInteractor extends core_1.Interactor {
    constructor(configModelOrConfig) {
        super();
        this.configModelOrConfig = configModelOrConfig;
        this.startX = 0;
        this.startY = 0;
        this.startBoxSize = {
            width: 0,
            height: 0
        };
        this.sub = new rxjs_1.Subscription();
        this.sizeModel = new core_1.Model({
            shouldApply: false,
            width: 0,
            height: 0
        });
        this.rootBoxSize = {
            width: 0,
            height: 0
        };
        this.didResizeStart = (x, y) => {
            if (this.presenter) {
                this.rootBoxSize = this.presenter.measureRootBox();
                this.startBoxSize = this.presenter.measureStartBox();
            }
            this.startX = x;
            this.startY = y;
        };
        this.didResizeEnd = () => {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            const newValue = this.sizeModel.getValue();
            if (this.onSizeChange && this.config) {
                const startSectionSize = this.config.isRow ? newValue.width : newValue.height;
                const endSectionSize = this.config.isRow
                    ? this.rootBoxSize.width - newValue.width
                    : this.rootBoxSize.height - newValue.height;
                const startSectionMinMaxSize = getLimitedValueByOptionalMinMaxValue({
                    value: startSectionSize,
                    minValue: (_b = (_a = this.config) === null || _a === void 0 ? void 0 : _a.startLimit) === null || _b === void 0 ? void 0 : _b.minSize,
                    maxValue: (_d = (_c = this.config) === null || _c === void 0 ? void 0 : _c.startLimit) === null || _d === void 0 ? void 0 : _d.maxSize
                });
                const endSectionMinMaxSize = getLimitedValueByOptionalMinMaxValue({
                    value: endSectionSize,
                    minValue: (_f = (_e = this.config) === null || _e === void 0 ? void 0 : _e.endLimit) === null || _f === void 0 ? void 0 : _f.minSize,
                    maxValue: (_h = (_g = this.config) === null || _g === void 0 ? void 0 : _g.endLimit) === null || _h === void 0 ? void 0 : _h.maxSize
                });
                this.onSizeChange(startSectionMinMaxSize, endSectionMinMaxSize);
            }
        };
        this.didMouseMove = (x, y) => {
            const diff = {
                x: x - this.startX,
                y: y - this.startY
            };
            this.updateSize(diff);
        };
        if (configModelOrConfig instanceof core_1.Model) {
            this.config = configModelOrConfig.getValue();
        }
        else {
            this.config = configModelOrConfig;
        }
    }
    updateSize(diff) {
        const [minWidth, maxWidth] = this.getLimitedSize();
        const [minHeight, maxHeight] = this.getLimitedSize(true);
        this.sizeModel.setValue({
            shouldApply: true,
            width: Math.round(Math.min(maxWidth, Math.max(this.startBoxSize.width + diff.x, minWidth))),
            height: Math.round(Math.min(maxHeight, Math.max(this.startBoxSize.height + diff.y, minHeight)))
        });
    }
    getLimitedSize(isColumnDirection) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const rootSize = isColumnDirection ? this.rootBoxSize.height : this.rootBoxSize.width;
        let minWidth = getSizeValue(((_b = (_a = this.config) === null || _a === void 0 ? void 0 : _a.startLimit) === null || _b === void 0 ? void 0 : _b.minSize) || 1, rootSize);
        if ((_d = (_c = this.config) === null || _c === void 0 ? void 0 : _c.endLimit) === null || _d === void 0 ? void 0 : _d.maxSize) {
            minWidth = Math.max(rootSize - getSizeValue(this.config.endLimit.maxSize, rootSize), minWidth);
        }
        let maxWidth = Math.min(getSizeValue(((_f = (_e = this.config) === null || _e === void 0 ? void 0 : _e.startLimit) === null || _f === void 0 ? void 0 : _f.maxSize) || rootSize, rootSize), rootSize);
        if ((_h = (_g = this.config) === null || _g === void 0 ? void 0 : _g.endLimit) === null || _h === void 0 ? void 0 : _h.minSize) {
            maxWidth = Math.min(Math.max(rootSize - getSizeValue(this.config.endLimit.minSize, rootSize), 1), maxWidth);
        }
        return [minWidth, maxWidth];
    }
    willActivate() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (this.configModelOrConfig instanceof core_1.Model) {
                this.sub.add((_a = this.configModelOrConfig) === null || _a === void 0 ? void 0 : _a.subscribe((config) => {
                    this.config = config;
                }));
            }
        });
    }
    willDeactivate() {
        return __awaiter(this, void 0, void 0, function* () {
            this.sub.unsubscribe();
        });
    }
}
exports.SplitLayoutInteractor = SplitLayoutInteractor;
//# sourceMappingURL=SplitLayoutInteractor.js.map